/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../Library';
import { Document } from '../core/models/Document';
import { Extension } from '../core/models/Extension';
import { Node } from '../core/models/Node';
import { ValidationProblem } from '../core/models/ValidationProblem';
import { Contact } from '../core/models/common/Contact';
import { ExternalDocumentation } from '../core/models/common/ExternalDocumentation';
import { Info } from '../core/models/common/Info';
import { License } from '../core/models/common/License';
import { Tag } from '../core/models/common/Tag';
import { IVisitor } from '../core/visitors/IVisitor';

/**
 * @author eric.wittmann@gmail.com
 * @class
 */
export abstract class ModelClonerVisitor implements IVisitor {
    __clone : Node;

    public getClone() : Node {
        if(this.__clone.ownerDocument() == null && this.__clone.parent() != null) {
            this.__clone._ownerDocument = this.__clone.parent().ownerDocument();
        }
        return this.__clone;
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitContact(io.apicurio.datamodels.core.models.common.Contact)
     * @param {Contact} node
     */
    public visitContact(node : Contact) {
        this.__clone = node.ownerDocument().createInfo().createContact();
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitDocument(io.apicurio.datamodels.core.models.Document)
     * @param {Document} node
     */
    public visitDocument(node : Document) {
        this.__clone = Library.createDocument(node.getDocumentType());
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitExtension(io.apicurio.datamodels.core.models.Extension)
     * @param {Extension} node
     */
    public visitExtension(node : Extension) {
        this.__clone = node.ownerDocument().createExtension();
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitExternalDocumentation(io.apicurio.datamodels.core.models.common.ExternalDocumentation)
     * @param {ExternalDocumentation} node
     */
    public visitExternalDocumentation(node : ExternalDocumentation) {
        this.__clone = node.ownerDocument().createExternalDocumentation();
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitInfo(io.apicurio.datamodels.core.models.common.Info)
     * @param {Info} node
     */
    public visitInfo(node : Info) {
        this.__clone = node.ownerDocument().createInfo();
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitLicense(io.apicurio.datamodels.core.models.common.License)
     * @param {License} node
     */
    public visitLicense(node : License) {
        this.__clone = node.ownerDocument().createInfo().createLicense();
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitTag(io.apicurio.datamodels.core.models.common.Tag)
     * @param {Tag} node
     */
    public visitTag(node : Tag) {
        this.__clone = node.ownerDocument().createTag();
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitValidationProblem(io.apicurio.datamodels.core.models.ValidationProblem)
     * @param {ValidationProblem} problem
     */
    public visitValidationProblem(problem : ValidationProblem) {
    }

    public abstract visitParameterDefinition(node?: any): any;
    public abstract visitSchemaDefinition(node?: any): any;
    public abstract visitSecurityScheme(node?: any): any;
    public abstract visitSecurityRequirement(node?: any): any;
    public abstract visitSchema(node?: any): any;
    public abstract visitOperation(node?: any): any;
    public abstract visitParameter(node?: any): any;
    constructor() {
        if(this.__clone===undefined) this.__clone = null;
    }
}
ModelClonerVisitor["__class"] = "io.apicurio.datamodels.cloning.ModelClonerVisitor";
ModelClonerVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor"];




